// ABOUTME: Opens Shopify's account sheet (<shopify-account>) with focus on the sheet itself, not a ringed close button, after a pointer or touch press (DP-12).
// The sheet's own code focuses its close button when it opens, and Safari rings a script focus that follows a tap (live's panels open with a plain x).
// While the latest input is a pointer or touch press, a focus that lands on the sheet's close button moves on to the sheet's dialog, which draws no ring
// (jf-brand.css); once a key is pressed (the sheet opened from the keyboard, or Tab inside it), the close button keeps focus and its ring. The sheet's
// open, close, Escape and modal focus containment are Shopify's and stay as they are; if Shopify renames the button or closes its shadow root, this does
// nothing.

const CLOSE_BUTTON_ID = 'close-button';

/* The latest input: a pointer or touch press (true) or a key (false). */
let pressedLast = false;
document.addEventListener('pointerdown', () => { pressedLast = true; }, { capture: true, passive: true });
document.addEventListener('keydown', () => { pressedLast = false; }, { capture: true });

/** @type {WeakSet<Element>} */
const watched = new WeakSet();

/**
 * Moves a focus that lands on the sheet's close button after a press on to the sheet's dialog.
 * @param {Element} host - A <shopify-account> element.
 */
function watch(host) {
  const root = host.shadowRoot;
  if (!root || watched.has(host)) return;
  watched.add(host);

  root.addEventListener('focusin', (event) => {
    const button = event.target;
    if (!pressedLast || !(button instanceof HTMLElement) || button.id !== CLOSE_BUTTON_ID) return;
    const dialog = button.closest('dialog');
    if (!dialog?.open) return;
    if (!dialog.hasAttribute('tabindex')) dialog.tabIndex = -1;
    dialog.focus({ preventScroll: true });
  });
}

customElements.whenDefined('shopify-account').then(() => {
  document.querySelectorAll('shopify-account').forEach(watch);
});
